var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-page"},[(_vm.isMobile)?_c('mobile-checkout-view',{attrs:{"orderId":_vm.orderId}}):_c('desktop-checkout-view',{attrs:{"orderId":_vm.orderId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }